module.exports = __webpack_public_path__ + "media/images/Gatilho-botao-86cae0eac91a081800d749f63a2394a3.svg";